import {
  createBiLogger as createCliBiLogger,
  reportCommandStartEvent as originalReportCommandStartEvent,
} from '@wix/cli-telemetry';
import { getUnknownFailureMessage, isCliSystemError } from '@wix/cli-error';
import type { ErrorReporter } from '@wix/cli-error-reporting';
import { wixCliCliError } from '@wix/bi-logger-dev-tools-data/v2';
import type { Command } from '@commander-js/extra-typings';

export const createBiLogger = async ({
  errorReporter,
  cliVersion,
  cliSessionId,
  userId,
  aiAgentName,
}: {
  errorReporter: ErrorReporter;
  cliVersion: string;
  cliSessionId: string;
  userId?: string;
  aiAgentName?: string;
}) => {
  const biLogger = await createCliBiLogger({
    aiAgentName,
    command: 'create-app',
    cliSessionId,
    cliVersion,
    userId,
  });

  errorReporter.on('errorReported', (error) => {
    void biLogger.report(
      wixCliCliError({
        errorMessage: getUnknownFailureMessage(error),
        errorType: isCliSystemError(error) ? 'SystemError' : 'UserError',
        errorName: error.name,
      })
    );
  });

  function reportCommandStartEvent(command: Command) {
    // creating a custom object because we need to change the name of the command
    const commandFields = {
      name: () => 'create-app',
      args: command.args,
      opts: () => command.opts(),
    };

    return originalReportCommandStartEvent({
      biLogger,
      command: commandFields,
      cliVersion,
      flow: 'Astro_App',
    });
  }

  return {
    biLogger,
    reportCommandStartEvent,
  };
};
